import { CheckCircleFilled } from '@ant-design/icons';

const renderItem = (key, value) => {
  if (!value) return null;
  if (key === 'max_team_member' || key === 'max_socmed_account') {
    return (
      <div className="component_column_value">
        {value}
        {/* <div className="font-paragraph">{value > 1 && 'Able to add more'}</div> */}
      </div>
    );
  }
  if (key === 'email_support') return `Within ${value} hours`;
  if (key === 'name') return value;
  return <CheckCircleFilled className="component_column_value_icon" />;
};

const columns = (values) => {
  const titleColumn = {
    render: (record) => {
      const { title, subtitle } = record;
      return (
        <div className="component_column_value">
          {title}
          <div className="font-paragraph">{subtitle}</div>
        </div>
      );
    },
  };
  const valueColumn = values?.map((item) => {
    return {
      render: (record) => {
        const { key } = record;
        const value = item?.[key];
        return renderItem(key, value);
      },
    };
  });

  return [titleColumn, ...valueColumn];
};

export default columns;
